import Fetch from "../../core/util/core/Fetch";
import { getUserSession, setUserSession } from "../../core/util/core/Session";
import config from "../config/config";

export const runAfterAuthentication = async () => {
    const session = getUserSession();
    session.loggedUserInfo = {};
    
    const loggedUserInfo = await Fetch.post(config.endpoints.backend + 'afterAuthentication', {
        core_user_id: session.user.id,
        core_application_profile_id: session.user.application_profile_id,
    });

    if(Object.keys(loggedUserInfo).length > 0){
        session.loggedUserInfo = loggedUserInfo;   
    }

    setUserSession(session)
}